<template>
  <AppView>
    <TopNav
      title="My Profile"
      title-class="lg:ml-body lg-app:tw-font-bold"
      center-title
      type="menu"
      @input="openSideNav()"
      :show-notification-icon="false"
      padd-bottom
      slot="top-app-view"
    />
    <div class="mx-body">
      <div class="tw-max-w-lg tw-mx-auto">
        <div v-if="error" v-html="error"></div>
        <div v-else-if="loading">
          <p class="opacity-54 tw-text-xs tw-text-center">Loading...</p>
        </div>
        <div v-else-if="user">
          <transition name="new" mode="out-in" appear>
            <div class="tw-inline-flex tw-flex-no-wrap tw-flex-none tw-mt-3 lg:tw-mx-auto">
              <div
                :class="[
                  'tw-inline-block tw-w-20 tw-h-20 tw-rounded-full tw-relative tw-cursor-pointer tw-flex-shrink-0',
                  {'tw-bg-gray-500' : isValidPhoto},
                  {'tw-bg-red-200' : !isValidPhoto},
                  {'opacity-11' : loadingPhoto},
                  {'tw-overflow-hidden': isValidPhoto && !loadingPhoto}
                ]"
                @click="promptUpdatePhoto"
              >
                <!-- PUT PROFILE PIC HERE -->
                <img v-if="isValidPhoto && !loadingPhoto" :src="form.photo || userPhoto(user.photo)" class="tw-w-full tw-h-full tw-object-cover tw-rounded-full" />
                <transition name="new" appear mode="out-in">
                  <span
                    style="transform: translateX(-50%); top: calc(100% + 4px);"
                    v-if="!isValidPhoto"
                    class="tw-text-red-500 leading-14 tw-text-xs tw-absolute tw-bottom-0 tw-left-1/2 tw-text-center tw-w-full"
                  >Photo needed!</span>
                </transition>
                <input
                  class="tw-hidden"
                  type="file"
                  ref="photo-input"
                  accept="image/*"
                  @change="addUserPhoto"
                />
              </div>
              <div class="tw-pt-3 tw-ml-6">
                <h4 class="tw-text-base lg:tw-text-xl leading-19 font-title tw-font-bold">{{ userFullName }}</h4>
                <!-- <h6 class="tw-font-light tw-text-xs leading-15 opacity-54 tw-mt-0 tw-uppercase">{{ user.country.country_name }}</h6> -->
                <h6 v-if="user.profession && isMentor" class="tw-font-bold tw-text-xs leading-15 opacity-54 tw-mt-1 tw-uppercase">{{ user.profession.profession }}</h6>
                <h6 v-else class="tw-font-bold tw-text-xs leading-15 opacity-54 tw-mt-1 tw-uppercase">{{ userTypeName }}</h6>
              </div>
            </div>
          </transition>
          <transition name="new" mode="out-in" appear>
            <!-- BIO -->
            <div class="tw-mt-14">
              <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
                <h5 :class="[
                  'tw-text-xs leading-15 tw-font-bold tw-py-2',
                  {'tw-text-red-500': !isValidBio},
                ]">Bio</h5>
                <BaseButton
                  text="Edit"
                  class="tw-text-black bg-black-11 tw-py-1 tw-border-none"
                  icon
                  v-if="!editMode.bio"
                  @click="promptUpdateBio"
                >
                  <svg version="1.1" class="my-btn__icon" slot="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
                    <path d="M5.6,72c-1.5,0-2.9-0.5-3.9-1.7C0.5,69.1,0,67.3,0,65.6l1.2-11.3c0.2-1.2,0.7-2.5,1.7-3.4L52,1.7c2.2-2.2,5.9-2.2,8.1,0
                      l10,10c2.2,2.2,2.2,5.9,0,8.1L20.8,69.1c-1,1-2.2,1.5-3.4,1.7l0,0L6.1,72C5.9,72,5.6,72,5.6,72z M17.2,68.1L17.2,68.1L17.2,68.1z
                      M56.1,4.8c0,0-0.2,0-0.5,0.2L6.1,54.4c-0.2,0.2-0.2,0.2-0.2,0.5L4.7,66.1c0,0.2,0.2,0.5,0.2,0.7s0.2,0.2,0.7,0.2l11.3-1.2
                      c0.2,0,0.2,0,0.5-0.2l49.3-49.3c0.2-0.2,0.2-0.7,0-1l-10-10C56.4,5.1,56.1,4.8,56.1,4.8z"/>
                  </svg>
                </BaseButton>
              </div>
              <transition name="fade" mode="out-in" appear>
                <div v-if="!editMode.bio">
                  <div v-if="isValidBio">
                    <h5 style="max-height: 44px;" class="tw-text-xs leading-14 opacity-54 tw-overflow-hidden ">{{ user.bio }}</h5>
                  </div>
                  <div
                    v-else
                    class="tw-rounded-sm tw-bg-red-100 tw-text-red-500 tw-text-center tw-py-4 tw-cursor-pointer"
                    @click="promptUpdateBio"
                  >
                    <p class=" tw-text-xs leading-14 tw-mb-3">You need to write your bio</p>
                    <BaseButton
                      text="Edit"
                      class="tw-text-black bg-black-11"
                      icon
                    >
                      <svg version="1.1" class="my-btn__icon" slot="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                          viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
                        <path d="M5.6,72c-1.5,0-2.9-0.5-3.9-1.7C0.5,69.1,0,67.3,0,65.6l1.2-11.3c0.2-1.2,0.7-2.5,1.7-3.4L52,1.7c2.2-2.2,5.9-2.2,8.1,0
                          l10,10c2.2,2.2,2.2,5.9,0,8.1L20.8,69.1c-1,1-2.2,1.5-3.4,1.7l0,0L6.1,72C5.9,72,5.6,72,5.6,72z M17.2,68.1L17.2,68.1L17.2,68.1z
                          M56.1,4.8c0,0-0.2,0-0.5,0.2L6.1,54.4c-0.2,0.2-0.2,0.2-0.2,0.5L4.7,66.1c0,0.2,0.2,0.5,0.2,0.7s0.2,0.2,0.7,0.2l11.3-1.2
                          c0.2,0,0.2,0,0.5-0.2l49.3-49.3c0.2-0.2,0.2-0.7,0-1l-10-10C56.4,5.1,56.1,4.8,56.1,4.8z"/>
                      </svg>
                    </BaseButton>
                  </div>
                </div>
                <div v-else>
                  <label class="tw-text-xs tw-text-black opacity-78">{{ bioLength }} / {{ maxBioLength }}</label>
                  <BaseTextarea
                    rows="3"
                    class="tw-border-b"
                    v-model="form.bio"
                    max-height="400px"
                    :value="user.bio"
                  />
                  <div class="tw-flex tw-justify-end tw-py-2">
                    <div>
                      <BaseButton
                        :text="saveBioBtnText"
                        class="tw-text-white tw-bg-black"
                        :disabled="!canSaveBio || saveBioBtnDisabled"
                        @click="saveBio"
                      />
                    </div>
                    <div class="tw-pl-4">
                      <BaseButton
                        text="Cancel"
                        class="tw-text-black bg-black-11"
                        @click="cancelEditingBio"
                      />
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </transition>
          <div class="tw-border opacity-18 tw-my-6"></div>
          <transition name="new" mode="out-in" appear>
            <!-- AVAILABILITY -->
            <div class="tw-mb-6">
              <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
                <h5 class="tw-text-xs leading-15 tw-font-bold tw-mb-1 tw-py-2">Availability</h5>
                <BaseButton
                  text="Edit"
                  class="tw-text-black bg-black-11 tw-py-1 tw-border-none"
                  icon
                  v-if="!editMode.availability || (canEditAvailability && !editMode.availability)"
                  @click="editMode.availability = true"
                >
                  <svg version="1.1" class="my-btn__icon" slot="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
                    <path d="M5.6,72c-1.5,0-2.9-0.5-3.9-1.7C0.5,69.1,0,67.3,0,65.6l1.2-11.3c0.2-1.2,0.7-2.5,1.7-3.4L52,1.7c2.2-2.2,5.9-2.2,8.1,0
                      l10,10c2.2,2.2,2.2,5.9,0,8.1L20.8,69.1c-1,1-2.2,1.5-3.4,1.7l0,0L6.1,72C5.9,72,5.6,72,5.6,72z M17.2,68.1L17.2,68.1L17.2,68.1z
                      M56.1,4.8c0,0-0.2,0-0.5,0.2L6.1,54.4c-0.2,0.2-0.2,0.2-0.2,0.5L4.7,66.1c0,0.2,0.2,0.5,0.2,0.7s0.2,0.2,0.7,0.2l11.3-1.2
                      c0.2,0,0.2,0,0.5-0.2l49.3-49.3c0.2-0.2,0.2-0.7,0-1l-10-10C56.4,5.1,56.1,4.8,56.1,4.8z"/>
                  </svg>
                </BaseButton>
              </div>
              <transition name="fade" mode="out-in" appear>
                <div v-if="!editMode.availability">
                  <ul class="">
                    <li
                      class="tw-inline-block tw-mr-4 tw-mb-1 opacity-54"
                      v-for="(availability, index) in user.availabilities"
                      :key="index"
                    >
                      {{ availability.availability }}
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <SelectGroup
                    label=""
                    name="availability"
                    instruct="You can add multiple values"
                    nameKey="availability"
                    placeholder="Experience"
                    v-model.lazy="form.userAvailability"
                    :options="availabilityList"
                    :reduce="availability => availability.id || availability"
                    :multiple="true"
                    :clearable="true"
                  />
                  <div class="tw-flex tw-justify-end tw-py-2">
                    <div>
                      <BaseButton
                        :text="saveAvailabilityBtnText"
                        class="tw-text-white tw-bg-black"
                        :disabled="form.availability.length === 0"
                        @click="saveAvailability"
                      />
                    </div>
                    <div class="tw-pl-4">
                      <BaseButton
                        text="Cancel"
                        class="tw-text-black bg-black-11"
                        @click="editMode.availability = false"
                      />
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </transition>
          <div id="license"></div>
          <div class="tw-border opacity-18 tw-my-6"></div>
          <template v-if="isMentee">
            <transition name="new" mode="out-in" appear>
              <!-- license -->
              <div class="tw-mb-6">
                <LicenseCard
                  :license="license"
                  :show-amount="false"
                  :license-status="!menteePackageIsExpired"
                >
                  <template slot="details">
                    <p
                      v-if="licenseStartDate && licenseExpiry"
                      :class="['tw-text-sm', {'tw-text-red-600': menteePackageIsExpired}]"
                    >
                      <span>Started on {{licenseStartDate | toJsDate | moment('Do MMMM YYYY')}}<br></span>
                      <span>|<br></span>
                      <span>Ends on {{licenseExpiry | toJsDate | moment('Do MMMM YYYY')}}<br></span>
                    </p>
                    <BaseButton
                      v-if="menteePackageIsExpired"
                      text="renew license"
                      class="tw-block tw-mt-4 tw-bg-black tw-text-white tw-py-3 tw-w-full"
                      :to="{name: 'license'}"
                    />
                    <!-- <BaseButton
                      v-else
                      text="buy another package"
                      class="tw-block tw-mt-4 tw-py-3 tw-w-full-- tw-text-base bg-black-11"
                      :to="{name: 'license'}"
                    /> -->
                  </template>
                </LicenseCard>
              </div>
            </transition>
            <div class="tw-border opacity-18 tw-my-6"></div>
            <transition name="new" mode="out-in" appear>
              <!-- WALLET -->
              <div class="tw-mb-6">
                <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
                  <h5 class="tw-text-xs leading-15 tw-font-bold tw-mb-1 tw-py-2">Your Wallet</h5>
                </div>
                <!-- wallet history -->
                <BaseCard class="tw-rounded-10 tw-bg-white tw-shadow-app tw-p-3">
                  <h5 class="tw-text-sm leading-15 tw-font-bold tw-mb-1 tw-py-2 opacity-54 tw-uppercase">Payment history</h5>

                  <table class="tw-table-fixed tw-w-full">
                    <thead>
                      <tr>
                        <th class="tw-border-r">package</th>
                        <th class="tw-border-r">date paid</th>
                        <!-- <th class="tw-border-r">id</th> -->
                        <th class="tw-border-r">phone number</th>
                        <th class="tw-border-">amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in walletHistory"
                        :key="item.id"
                        class="tw-text-xs"
                      >
                        <td class="tw-py-2 sm:tw-px-3 tw-border tw-break-words">{{ (getPackageById(item.packid) || {}).name }}</td>
                        <td class="tw-py-2 sm:tw-px-3 tw-border">{{item.dateOfPost | toJsDate | moment('calendar') }}</td>
                        <!-- <td class="tw-py-2 tw-px-3 tw-border">{{item.id}}</td> -->
                        <td class="tw-py-2 sm:tw-px-3 tw-border tw-break-all">{{item.MSISDN}}</td>
                        <td class="tw-py-2 sm:tw-px-3 tw-border">ksh.{{item.TransAmount}}</td>
                      </tr>
                    </tbody>
                  </table>
                </BaseCard>
              </div>
            </transition>
            <div class="tw-border opacity-18 tw-my-6"></div>
          </template>
        </div>
      </div>
    </div>
  </AppView>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectGroup from '@/components/SelectGroup.vue';
import LicenseCard from '@/components/LicenseCard.vue';

import { apiPost, apiGet, generateFormData } from '@/modules/apiHelper';
import profileMixin from '@/mixins/profile';
import { getPhoto } from '@/modules/dataHelper';

export default {
  name: 'UserProfile',
  components: {
    SelectGroup,
    LicenseCard,
  },
  mixins: [profileMixin],
  data() {
    return {
      loading: true,
      error: undefined,
      user: {},
      canEditAvailability: false,
      saveBioBtnText: 'Save bio',
      saveBioBtnDisabled: false,
      saveAvailabilityBtnText: 'Save',
      availabilityList: [],
      walletHistory: [],
      packages: [],
      pillars: [],
      form: {
        photo: '',
        photoFile: undefined,
        bio: '',
        availability: [],
        userAvailability: [],
        linkedIn: undefined,
      },
      editMode: {
        bio: false,
        photo: false,
        availability: false,
      },
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.photoFile': function (val) {
      if (val) {
        this.loadingPhoto = true;

        getPhoto(this.form.photoFile, (event) => {
          this.form.photo = event.target.result;
          this.savePhoto();
        });

        return '';
      }
      return true;
    },
    // eslint-disable-next-line func-names
    'form.userAvailability': function (val) {
      this.form.availability = val;
    },
  },
  computed: {
    ...mapGetters([
      'userTypeName',
      'userId',
    ]),
    userFullName() {
      return `${this.user.name} ${this.user.last_name}`;
    },
    canSaveProfile() {
      return this.form.photoFile || this.form.availability;
    },
    license() {
      return this.$store.state.User.mentee.license.package;
    },
  },
  methods: {
    async promptUpdateBio() {
      this.form.bio = this.user.bio;
      this.editMode.bio = true;
      await this.$nextTick();
      await this.$nextTick();
    },
    cancelEditingBio() {
      this.editMode.bio = false;
      this.form.bio = '';
    },
    async savePhoto() {
      if (!this.canSaveProfile) return false;
      this.loadingPhoto = true;

      const result = await this.$store.dispatch('updateUserPhoto', this.form.photoFile);

      if (!result) {
        this.$toasted.global.appError({ errorMessage: 'Profile photo could not be uploaded, please try again.' });
      } else {
        await this.$store.dispatch('deleteUserData', this.userId);
        const user = await this.$store.dispatch('getUserData', this.userId);
        this.user = { ...(user || {}) };

        this.$toasted.success('Profile photo saved!', {
          duration: 3000,
          position: 'top-right',
        });
      }

      this.loadingPhoto = false;
      return true;
    },
    async saveBio() {
      if (!this.canSaveBio) return false;
      this.saveBioBtnText = 'saving...';
      this.saveBioBtnDisabled = true;

      const result = await this.$store.dispatch('updateUserBio', this.form.bio);

      if (!result) {
        this.$toasted.global.appError({ errorMessage: 'Bio could not be uploaded, please try again.' });
      } else {
        await this.$store.dispatch('deleteUserData', this.userId);
        const user = await this.$store.dispatch('getUserData', this.userId);
        this.user = { ...(user || {}) };

        this.$toasted.success('Bio updated!', {
          duration: 3000,
          position: 'top-right',
        });

        this.editMode.bio = false;
      }

      this.saveBioBtnDisabled = false;
      this.saveBioBtnText = 'Save Bio';
      return true;
    },
    async saveAvailability() {
      if (this.form.availability.length === 0) return false;
      this.saveAvailabilityBtnText = 'saving...';

      const result = await this.$store.dispatch('updateUserAvailability', this.form.availability);

      if (!result) {
        this.$toasted.global.appError({ errorMessage: 'Availability could not be uploaded, please try again.' });
      } else {
        await this.$store.dispatch('deleteUserData', this.userId);
        const user = await this.$store.dispatch('getUserData', this.userId);
        this.user = { ...(user || {}) };

        this.$toasted.success('Availability updated!', {
          duration: 3000,
          position: 'top-right',
        });

        this.form.userAvailability = this.user.availability;
        this.editMode.availability = false;
      }

      this.saveAvailabilityBtnText = 'Save';
      return true;
    },
    async save() {
      await Promise.all([
        this.saveBio(),
        this.saveAvailability(),
        this.savePhoto(),
      ]);
    },
    getPackageById(packageId) {
      return this.packages.find(aPackage => Number(aPackage.id) === Number(packageId)) || {};
    },
    getPillarById(pillarId) {
      return this.pillars.find(pillar => Number(pillar.id) === Number(pillarId)) || {};
    },
  },
  async created() {
    this.$store.commit('isFlatView', false);

    await this.$store.dispatch('getUserData', this.userId)
      .catch((err) => {
        const errorMessage = 'Error in preparing your profile';
        console.warn(errorMessage, err);
        this.$toasted.global.appError({ errorMessage });
      })
      .then((user) => {
        this.user = { ...(user || {}) };
        this.form.userAvailability = this.user.availability;

        if (!this.isValidBio || !this.isValidPhoto) {
          this.$toasted.info('You need to add your bio and profile photo', {
            duration: 4000,
            position: 'top-right',
          });
        }

        this.loadingPhoto = false;
        this.loading = false;
      });
    //

    apiGet('availability')
      .catch((err) => {
        console.warn(err);
        this.canEditAvailability = false;
      })
      .then((res) => {
        if (!res || (res || {}).error) {
          this.canEditAvailability = false;
          return false;
        }

        this.availabilityList = res.data.availability;
        this.canEditAvailability = true;
        return true;
      });
    //

    apiPost('pay_hist', generateFormData({ userid: this.user.id }), 15)
      .catch((err) => {
        const errorMessage = 'Error in getting your wallet history';
        console.warn(errorMessage, err);
        this.$toasted.global.appError({ errorMessage });
      })
      .then((res) => {
        if (!res || (res || {}).error) {
          return false;
        }

        this.walletHistory = res.data.pay_hist;

        return true;
      });
    //

    Promise.all([
      this.$store.dispatch('getPackages'),
      this.$store.dispatch('getPillarGroups', []),
    ]).then(([packages, pillars]) => {
      this.packages = packages;
      this.pillars = pillars;
    });
  },
};
</script>

<style>

</style>
